<template>
    <Head>
        <title>{{title}}</title>
        <meta name="description" content="Détail d'un véhicule">
    </Head>
    <Header :agency="agency" :bg_img="bg_img"></Header>
    <Layout>

        <div class="content-blocks">

            <section class="page-header-section full-view-header announce-header"
                :style="image">
                <img :src="require('@assets/images/misc/booked-flag.png').default" v-if="ad.is_booked && !ad.is_solded" alt="Réservé" style="position: absolute; top: 0; left: 0; z-index:2; width:300px;max-width:50vw;">
                <img :src="require('@assets/images/misc/sold-flag.png').default" v-if="ad.is_solded" alt="Vendu" style="position: absolute; top: 0; left: 0;z-index:2; width:300px;max-width:50vw;">
                <div class="like-button" :class="{fav:inFavorites}" @click="addToFavoris"></div>

                <!-- Share Button with Dropdown -->
                <ShareButton :ad="ad"/>

                <div class="car-title">
                    <div class="car-title-flex show">
                        <img :src="require('@assets/images/misc/fiable-ou-rembourse.svg').default" v-if="ad.is_reliable_or_refunded" alt="Logo Fiable ou remboursé" class="ad-logo-reliable-label">
                        <div>
                            <h1 class="title">{{ad.make}} {{ad.model}}</h1>
                            <p class="sub-title">{{ad.version}}</p>
                        </div>
                    </div>

                </div>

                <div class="car-infos">
                    <div class="block-icons">
                        <div class="icon">
                            <img class="lazyload" data-src="https://www.ewigo.com/wp-content/themes/ewigo/assets/images/boite-de-vitesses-blanc.svg"
                                alt="">
                            <p>{{ gear }}</p>
                        </div>
                        <div class="icon">
                            <img class="lazyload" data-src="https://www.ewigo.com/wp-content/themes/ewigo/assets/images/calendrier-blanc.svg"
                                alt="">
                            <p>{{ad.year}}</p>
                        </div>
                        <div class="icon">
                            <img class="lazyload" data-src="https://www.ewigo.com/wp-content/themes/ewigo/assets/images/compteur-intelligent-blanc.svg"
                                alt="">
                            <p>{{km}} Kms</p>
                        </div>
                        <div class="icon">
                            <img class="lazyload" data-src="https://www.ewigo.com/wp-content/themes/ewigo/assets/images/station-essence-blanc.svg"
                                alt="">
                            <p>{{energy}}</p>
                        </div>
                        <div class="icon">
                            <img class="lazyload" data-src="/img/voiture-CV.svg"
                                alt="">
                            <p>{{ad.horse_power_tax}} CV</p>
                        </div>
                        <div class="icon badge">
                            <img class="lazyload" data-src="https://www.ewigo.com/wp-content/themes/ewigo/assets/images/badge.svg"
                                alt="">
                            <p>{{ad.warranty_1_duration}} mois</p>
                        </div>
                    </div>
                </div>

                <div class="price">
                    <p>{{ad.price_format}} €</p>
                </div>
                <div class="header-sliders">
                    <div class="slider">
                        <span><img class="lazyload" data-src="https://www.ewigo.com/wp-content/uploads/2021/09/appel-telephonique.png"
                                alt=""></span>
                        <a :href="`tel:${agency.phone}`" id="vehicle_agency_phone">{{agency.phone}}</a>
                    </div>
                    <div class="slider">
                        <span><img class="lazyload" data-src="https://www.ewigo.com/wp-content/uploads/2021/09/expedie-1.png"
                                alt=""></span>
                        <a href="#livraison">Livraison</a>
                    </div>
                    <div class="slider">
                        <span><img class="lazyload" data-src="https://www.ewigo.com/wp-content/uploads/2021/09/euro.png" alt=""></span>
                        <a href="#financement">Financement</a>
                    </div>
                </div>
                <div class="container">
                </div>
            </section>

            <vue-easy-lightbox
                :visible="lightboxVisible"
                :imgs="ad.gallery"
                :index="lightboxIndex"
                @hide="handleLightboxHide"
                :moveDisabled="true"
            ></vue-easy-lightbox>

            <section class=" announce-calculator">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-6 col-xl-8">
                            <img :src="require('@assets/images/misc/booked-flag.png').default" v-if="ad.is_booked && !ad.is_solded" alt="Réservé" style="position: absolute; top: 0; left: 0; z-index:2; width:300px;max-width:50vw;">
                            <img :src="require('@assets/images/misc/sold-flag.png').default" v-if="ad.is_solded" alt="Vendu" style="position: absolute; top: 0; left: 0;z-index:2; width:300px;max-width:50vw;">
                            <div class="slider-block">
                                <div class="slider" v-for="(image, index)  in ad.gallery_thumb" :key="image">
                                    <div class="slide">
                                         <img class="lazyload" :data-src="image" alt="" @click="() => showLightboxImg(index)">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-xl-4" id="financement">
                            <div class="form-section">
                                <h3 class="h3">Votre financement</h3>
                                <div class="list">
                                    <ul class="checklist" style="margin-top: 40px;">
                                        <li>
                                            <p>Votre financement en moins de 5 min</p>
                                        </li>
                                        <li>
                                            <p>Une réponse de principe instantanée</p>
                                        </li>
                                        <li>
                                            <p>Sans engagement</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="form-block range-calculator">
                                    <div class="form-group range-input">
                                        <label for="">
                                            <span class="main">Durée</span>
                                            <span>
                                                <p class="sub">{{duree}} mois</p>
                                            </span>
                                        </label>
                                        <div class="input-block">
                                            <input type="range" name="" id="range1" min="12" max="72" step="12" v-model="duree"
                                            :style="{
                                                'background': 'linear-gradient(to right, #FF8900 0%, #FF8900 ' + ( (duree - 12 )/ (72 - 12) * 100) + '%, #e4e4e4 ' + ( (duree - 12 )/ (72 - 12) * 100) + '%, #e4e4e4 100%)'
                                                }"
                                            >
                                        </div>
                                    </div>
                                    <div class="form-group range-input">
                                        <label for="">
                                            <span class="main">Apport</span>
                                            <span>
                                                <p class="sub">{{apport}} euros</p>
                                            </span>
                                        </label>
                                        <div class="input-block">
                                            <input type="range" name="" id="range2" min="0" step="100" :max="apportMax" v-model="apport"
                                            :style="{
                                                'background': 'linear-gradient(to right, #FF8900 0%, #FF8900 ' + (apport*100/apportMax) + '%, #e4e4e4 ' + (apport*100/apportMax) + '%, #e4e4e4 100%)'
                                                }"
                                            >
                                        </div>
                                    </div>
                                    <div class="answer-block" style="margin: 50px 0;">
                                        <p style="text-align:center;width:100%;margin:0;">à partir de * <b><span class="primary">{{mensualite}} €</span>/mois</b></p>
                                    </div>
                                    <p style="text-align: center;margin: 20px;"><a class="primary-btn btn"
                                            :href="lenboxUrl" target="_blank">Réaliser ma demande</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section class="page-header-section reserve-vehicle">
                <div class="section-header">
                    <h2 class="title">Réserver ce véhicule</h2>
                    <p class="desc">Intéressé par ce véhicule ? L’équipe EWIGO de {{agency.name}} vous informe</p>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-4">
                            <div class="address-col"
                                :style="'background-image: url(/carte/' + agency.city.toLowerCase() + '.svg); background-size: 241px;'">
                                <h3 class="title">
                                    Disponible à </h3>
                                <p>
                                    {{agency.city}} ({{agency.department_number}}) </p>
                                <p>
                                    {{agency.phone}} <br />
                                    {{agency.email}} </p>
                                <p>
                                    {{agency.address}} {{agency.postcode}} {{agency.city}}. </p>
                                <img class="lazyload" data-src="https://www.ewigo.com/wp-content/uploads/2024/10/Avis-client_Page-e1730281367986.png" alt="">
                            </div>
                        </div>
                        <div class="col-lg-4" id="livraison">
                            <div class="address-col livraison"
                                style="background-image: url('https://www.ewigo.com/wp-content/uploads/2021/09/expedie.png'); ">
                                <h3 class="title">
                                    Livraison </h3>
                                <p class="desc">
                                    Pas la porte à côté ? Bénéficiez de la livraison de votre véhicule partout en France !
                                </p>
                                <div class="form-block">
                                    <div class="input-box">
                                        <input type="text" placeholder="Saisir l'adresse de livraison" v-model="shippingAddress">
                                    </div>
                                    <div class="submit-button">
                                        <input type="submit" @click="driiveme" id="calcul_livraison">
                                    </div>
                                </div>
                                <div class="driiveme" v-if="driivemeData">
                                    <p><b>Départ :</b> {{ driivemeData.fromAddress }}</p>
                                    <p><b>Destination :</b> {{ driivemeData.toAddress }}</p>
                                    <p><b>Prix :</b> {{ driivemeData.price }} €</p>
                                </div>

                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="address-col reprise">
                                <h3 class="title">
                                    Reprise </h3>
                                <p class="desc">
                                    Besoin d’une solution de reprise pour votre véhicule ? <br>
                                    Nos agents Ewigo réalisent une estimation gratuite ! </p>
                                <form :action="route('minisite.landing-page-reprise-depot')" method="get" class="form-block">
                                    <div class="input-box">
                                        <input type="hidden" name="reference" :value="ad.id">
                                        <input type="text" placeholder="Plaque d’immatriculation" name="registration"
                                        v-model="registration"
                                        v-mask="getRegistrationMask"
                                        masked="true"
                                         >
                                    </div>
                                    <div class="submit-button">
                                        <input type="submit">
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <section class="seperator-section"
                :style="image">
                <div class="container">
                    <h3 class="h3 white">Équipements et Options</h3>
                </div>
            </section>



            <section class="page-header-section announce-equipments">

                <div class="modal_equipments" :style="[showEquipments ? {display: 'block' } : {display: 'none' }]">

                        <div class="close hide_equipments sticky" @click="showEquipments = false">X</div>


                    <div class="test">
                        <div class="blocks_equipments">
                            <div class="block_equipments" v-if="ad.equipments.exterior">
                                <h3 class="title">Options extérieures</h3>
                                <ul>
                                    <li v-for="(equipment, index) in ad.equipments.exterior" :key="index">{{equipment}}</li>
                                </ul>
                            </div>
                            <div class="block_equipments"  v-if="ad.equipments.security">
                                <h3 class="title">Sécurité </h3>
                                <ul>
                                    <li v-for="(equipment, index) in ad.equipments.security" :key="index">{{equipment}}</li>
                                </ul>
                            </div>
                            <div class="block_equipments" v-if="ad.equipments.interior">
                                <h3 class="title">Options intérieures</h3>
                                <ul>
                                    <li v-for="(equipment, index) in ad.equipments.interior" :key="index">{{equipment}}</li>
                                </ul>
                            </div>
                            <div class="block_equipments" v-if="ad.equipments.other">
                                <h3 class="title">Autre</h3>
                                <ul>
                                    <li v-for="(equipment, index) in ad.equipments.other" :key="index">{{equipment}}</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>


                <div class="section-inner">
                    <div class="left-image-list">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-6">
                                    <img class="lazyload" data-src="https://www.ewigo.com/wp-content/uploads/2022/01/exterieur-et-chassis-e1649310152344.png"
                                        alt="">
                                </div>
                                <div class="col-md-6">
                                    <h3 class="title">Extérieur</h3>
                                    <ul v-if="ad.equipments.exterior">
                                        <template v-for="(equipment, index) in ad.equipments.exterior">
                                            <li v-if="index < 15">{{equipment}}</li>
                                        </template>
                                    </ul>
                                    <a class="primary-btn btn show_equipments" @click="showEquipments = true" v-if="ad.equipments.exterior && ad.equipments.exterior.length > 0">Voir toutes les options</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right-image-list">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-6 image-mobile">
                                    <img class="lazyload" data-src="https://www.ewigo.com/wp-content/uploads/2022/10/interieur-opti.png"
                                        alt="">
                                </div>
                                <div class="col-md-6">
                                    <h3 class="title">Intérieur</h3>
                                    <ul v-if="ad.equipments.interior">
                                        <template v-for="(equipment, index) in ad.equipments.interior">
                                            <li v-if="index < 15">{{equipment}}</li>
                                        </template>
                                    </ul>
                                    <a class="primary-btn btn show_equipments" @click="showEquipments = true" v-if="ad.equipments.interior && ad.equipments.interior.length > 0">Voir toutes les options</a>
                                </div>
                                <div class="col-md-6 image-desktop">
                                    <img class="lazyload" data-src="https://www.ewigo.com/wp-content/uploads/2022/10/interieur-opti.png"
                                        alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="seperator-section"
                :style="image">
                <div class="container">
                    <h3 class="h3 white">État du véhicule</h3>
                </div>
            </section>



            <section class="page-header-section etat-vehicle">
                <div class="section-inner">
                    <div class="container inspection">


<!-- début intégration inspecteur -->

                        <div class="step-2 inspection" >


                            <div class="row">

                                <div class="col-md-12">
                                    <div class="slider-block">

                                        <div v-for="(subTab, subTabIndex) in subTabs" :key="subTabIndex" class="page-break">
                                            <div class="slider">
                                                <div class="slide">
                                                    <div class="subtitle">{{subTab}}</div>


                                                    <div :class="'substep-' + (subTab)" >
                                                        <div class="preview slickLightbox">
                                                            <div class="canvas">

                                                                <div v-for="(question, index) in screens[subTab]" :key="question.code"
                                                                    class="bubble-question"
                                                                        :class="[question.value != '' && question.value != '0' && question.value != '-1' && (question.value != '2' || question.profil == 'usure') ? 'qsuccess' : '',
                                                                        question.value == '0' ? 'qerror': '',
                                                                        question.value == '2' && question.profil != 'usure' ? 'qinfo': '',
                                                                        currentQuestion == question.code ? 'qwarning' : '']"
                                                                    :style="{left: question.positionX + 'px', top: question.positionY + 'px'}">
                                                                    <a
                                                                    v-if="question.value == '0'"
                                                                    :href="`${this.$page.props.ewigoExtranetUrl}/vehicules/${ad.id}/inspections/${question.media_id}`">
                                                                        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                                                                            <path fill="currentColor" d="M4,4H7L9,2H15L17,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z" />
                                                                        </svg>
                                                                    </a>

                                                                </div>
                                                                <img :src="require('@assets/images/inspector-images/SL_' + subTab + '.png').default" alt="inspector">
                                                            </div>
                                                        </div>

                                                        <div class="block-questions">
                                                            <p v-if="!checkQuestions(screens[subTab])" class="noAnomaly">Aucune anomalie détectée</p>
                                                            <div v-for="(question, index) in screens[subTab]" :key="question.code"
                                                                class="block-question"
                                                                    :class="[question.value != '' && question.value != '0' && question.value != '-1' && (question.value != '2' || question.profil == 'usure') ? 'qsuccess' : '',
                                                                    question.value == '0' ? 'qerror': '',
                                                                    question.value == '2' && question.profil != 'usure' ? 'qinfo': '',
                                                                    currentQuestion == question.code ? 'qwarning' : '',
                                                                    question.profil == 'radio' ? 'block-radio' : '',
                                                                    question.profil == 'input' ? 'block-inputs': '',
                                                                    question.profil == 'usure' ? 'block-radio' : ''] "
                                                            >
                                                                <div class="question">{{question.name}}</div>

                                                                <div class="response" v-if="question.profil == 'yesno'">
                                                                    <input disabled type="radio" :id="question.code + '-ok'"
                                                                        :name="'response[' + question.code + ']'" value="1"
                                                                        :checked="question.value == 1"><label :for="question.code + '-ok'"><img
                                                                    :src="require('@assets/images/inspector-images/check.svg').default" alt="check"></label>
                                                                    <input disabled type="radio" :id="question.code + '-ko'"
                                                                        :name="'response[' + question.code + ']'" value="0"
                                                                        :checked="question.value == 0"><label :for="question.code + '-ko'"><img
                                                                    :src="require('@assets/images/inspector-images/error.svg').default" alt="error"></label>
                                                                </div>

                                                                <div class="list-response" v-if="question.profil == 'radio'">
                                                                    <div v-for="(radioValue, radioIndex) in question.values" :key="radioIndex">
                                                                        <input disabled v-model="question.value"
                                                                            type="radio"
                                                                            :id="'response[' + question.code + ']' + radioIndex"
                                                                            :name="'response[' + question.code + ']'"
                                                                            :value="radioValue"
                                                                        >
                                                                        <label :for="'response[' + question.code + ']' + radioIndex">{{radioValue}}</label>
                                                                    </div>
                                                                </div>


                                                                <div class="response" v-if="question.profil == 'yesnoex'">
                                                                    <input disabled type="radio" :id="question.code + '-ex'"
                                                                        :name="'response[' + question.code + ']'" value="2"
                                                                        v-on:change="question.value = 2;downBubble(question, index);checkAllValues()"
                                                                        :checked="question.value == 2"><label :for="question.code + '-ex'"><img
                                                                    :src="require('@assets/images/inspector-images/no.svg').default" alt="no"></label>
                                                                    <input disabled type="radio" :id="question.code + '-ok'"
                                                                        :name="'response[' + question.code + ']'" value="1"
                                                                        :checked="question.value == 1"><label :for="question.code + '-ok'"><img
                                                                    :src="require('@assets/images/inspector-images/check.svg').default" alt="check"></label>
                                                                    <input disabled type="radio" :id="question.code + '-ko'"
                                                                        :name="'response[' + question.code + ']'" value="0"
                                                                        :checked="question.value == 0"><label :for="question.code + '-ko'"><img
                                                                    :src="require('@assets/images/inspector-images/error.svg').default" alt="error"></label>
                                                                </div>



                                                                <div class="response" v-if="question.profil == 'pneus'">
                                                                    <input disabled type="radio" :id="question.code + '-ok'"
                                                                        :name="'response[' + question.code + ']'" value="1"
                                                                        v-on:change="question.value = 'ete';downBubble(question, index);checkAllValues()"
                                                                        :checked="question.value == 'ete'"><label :for="question.code + '-ok'"><img
                                                                    :src="require('@assets/images/inspector-images/ete.svg').default" alt="ete"></label>
                                                                    <input disabled type="radio" :id="question.code + '-ko'"
                                                                        :name="'response[' + question.code + ']'" value="0"
                                                                        v-on:change="question.value = 'hiver';downBubble(question, index);checkAllValues()"
                                                                        :checked="question.value == 'hiver'"><label :for="question.code + '-ko'"><img
                                                                    :src="require('@assets/images/inspector-images/hiver.svg').default" alt="hivers"></label>
                                                                    <input disabled type="radio" :id="question.code + '-4'"
                                                                        :name="'response[' + question.code + ']'" value="2"
                                                                        v-on:change="question.value = '4saisons';downBubble(question, index);checkAllValues()"
                                                                        :checked="question.value == '4saisons'"><label :for="question.code + '-4'"><img
                                                                    :src="require('@assets/images/inspector-images/4-saisons.svg').default" alt="4-saisons"></label>
                                                                </div>

                                                                <div class="response" v-if="question.profil == 'usure'" style="align-items: flex-end;flex-wrap: wrap;">
                                                                    <div class="range-usure">
                                                                        <input type="range"
                                                                                disabled
                                                                            :id="question.code"
                                                                            v-model="question.value"
                                                                            :name="'response[' + question.code + ']'"
                                                                            min="1" max="9" step="1">
                                                                    </div>
                                                                    <span>{{usurePercentage(question.value)}}%</span>
                                                                    <div class="replace_tires" v-if="question.value <= 3">Remplacement conseillé</div>
                                                                </div>

                                                                <div class="response" v-if="question.profil == 'input' && !question.mask">
                                                                    <div class="block-input">
                                                                        <input type="text"
                                                                                disabled
                                                                            :id="question.code"
                                                                            v-model="question.value"
                                                                            :name="'response[' + question.code + ']'"
                                                                            :placeholder="question.placeholder"
                                                                            class="plate-input">
                                                                    </div>
                                                                </div>

                                                                <div class="response" v-if="question.profil == 'input' && question.mask">
                                                                    <div class="block-input">
                                                                        <input type="text"
                                                                                disabled
                                                                            :id="question.code"
                                                                            v-model="question.value"
                                                                            :name="'response[' + question.code + ']'"
                                                                            :placeholder="question.placeholder"
                                                                            class="plate-input">
                                                                    </div>
                                                                </div>

                                                                <div class="problem" v-if="question.value == '0'">
                                                                    <div class="content">
                                                                        <span>Note :</span>
                                                                        <p>{{question.note}}</p>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-12 col-xl-6">
                                    <div class="slider-nav">
                                        <div v-for="(subTab, subTabIndex) in subTabs" :key="`nav-${subTabIndex}`" class="slider">
                                            <div class="slide">
                                                <img :src="require('@assets/images/inspector-images/SL_' + subTab + '.png').default" alt="inspector">
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>


<!-- fin intégration inspecteur -->


                    </div>
                    <div class="newsletter-popup">
                        <img class="lazyload" :data-src="ad.photo_sales" alt="">
                        <div v-if="contactResult">
                            <h3>Demande Enregistrée <img src="/img/success.svg" alt="success"></h3>
                            <p>
                                L’équipe Ewigo {{agency.name}} vous recontactera dans les plus brefs délais
                            </p>
                        </div>
                        <div v-else>
                            <h3>Intéressé par ce véhicule ?</h3>
                            <p>L’équipe EWIGO de {{agency.name}} se fera un plaisir de vous renseigner </p>
                            <div class="search-block">
                                <div class="form-block">
                                    <div class="input-box">
                                        <input type="text" placeholder="Votre téléphone" v-model="phone"
                                               v-mask="'## ## ## ## ##'"
                                               masked="true">
                                    </div>
                                    <div class="submit-button">
                                        <input type="submit" @click="contact" id="demande_rappel">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section class="page-header-section etats-des-pneus">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-4">
                            <h3 class="title-pneus-mobile">États des pneus</h3>
                        </div>
                        <div class="col-lg-4">
                            <img data-src="https://www.ewigo.com/wp-content/uploads/2022/10/wheel-opti.png"
                                alt="" class="lazyload img-fluid">
                        </div>
                        <div class="col-lg-8">
                            <h3 class="title-pneus-desktop">États des pneus</h3>


                            <div class="table-outer">
                                <div class="table-wrapper">
                                    <table>
                                        <thead>
                                        <tr>
                                            <td>-</td>
                                            <td>Détails</td>
                                            <td>% d’usure</td>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>Avant Gauche</td>
                                            <td>{{pneus.MA}}<br>{{pneus.DAV}}</td>
                                            <td>{{usurePercentage(pneus.UA)}}%</td>
                                        </tr>
                                        <tr>
                                            <td>Avant Droit</td>
                                            <td>{{pneus.MA}}<br>{{pneus.DAV}}</td>
                                            <td>{{usurePercentage(pneus.UA)}}%</td>
                                        </tr>
                                        <tr>
                                            <td>Arrière Gauche</td>
                                            <td>{{pneus.MR}}<br>{{pneus.DRV}}</td>
                                            <td>{{usurePercentage(pneus.UR)}}%</td>
                                        </tr>
                                        <tr>
                                            <td>Arrière Droit</td>
                                            <td>{{pneus.MR}}<br>{{pneus.DRV}}</td>
                                            <td>{{usurePercentage(pneus.UR)}}%</td>
                                        </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section class="page-header-section announce-timeline">
                <div class="container">
                    <div class="historique">
                        <h2 class="title">Historique d’entretien</h2>
                        <ul class="timeline">
                            <img data-src="https://www.ewigo.com/wp-content/uploads/2022/10/piston-opti.png" alt="" class="lazyload img-fluid img-piston">
                            <li v-for="(maintenance, index) in futureMaintenances" class="future-maintenance" :key="`maintenance-${index}`">
                                <div class="orange-dot grey-dot">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.48795 4.25756e-06C8.88522 -0.000129502 8.29026 0.135945 7.74752 0.398059C7.20478 0.660174 6.72828 1.04155 6.35365 1.5137C5.97901 1.98584 5.71591 2.53654 5.58401 3.12466C5.45211 3.71277 5.45483 4.32309 5.59195 4.91L0.540945 10.145C0.183718 10.5239 -0.0103905 11.028 0.000429211 11.5486C0.0112489 12.0693 0.226131 12.5648 0.598792 12.9286C0.971453 13.2923 1.47207 13.4951 1.99283 13.4933C2.51358 13.4916 3.01279 13.2853 3.38295 12.919L8.38995 7.847C9.02885 8.02887 9.70298 8.04883 10.3515 7.90509C11.0001 7.76136 11.6026 7.45844 12.1049 7.02367C12.6071 6.5889 12.9932 6.03594 13.2284 5.41467C13.4636 4.79341 13.5404 4.12337 13.4519 3.465C13.4397 3.37244 13.4017 3.28516 13.3424 3.21306C13.283 3.14096 13.2047 3.08691 13.1162 3.05704C13.0278 3.02717 12.9327 3.02267 12.8418 3.04405C12.7509 3.06543 12.6678 3.11183 12.6019 3.178L10.4879 5.293L8.19495 3L10.3099 0.885004C10.3761 0.819126 10.4225 0.736033 10.4439 0.645138C10.4653 0.554243 10.4608 0.459177 10.4309 0.370709C10.401 0.28224 10.347 0.203904 10.2749 0.144573C10.2028 0.0852411 10.1155 0.0472853 10.0229 0.0350042C9.84526 0.0114363 9.66619 -0.000256228 9.48695 4.25756e-06H9.48795Z" fill="black"/>
                                    </svg>
                                </div>
                                <div class="flex-column">
                                    <div class="future-maintenance-title">Prochain entretien prévu :</div>
                                    <div class="block-date">
                                        <img src="https://www.ewigo.com/wp-content/themes/ewigo/assets/images/calendrier-noir.svg" alt="" class="icon">
                                        <div class="date" v-if="maintenance.date">
                                            {{dateTime(maintenance.date)}}
                                        </div><div style="font-size:1.2rem" v-else>Non renseigné</div>
                                    </div>
                                    <div class="block-mileage">
                                        <img src="https://www.ewigo.com/wp-content/themes/ewigo/assets/images/compteur-intelligent-noir.svg" alt="" class="icon">
                                        <div class="text">
                                            <h3 class="title"><span v-if="maintenance.mileage && !maintenance.mileage.toString().includes('entretien')">{{maintenance.mileage}} km</span><span style="color:#000000" v-else>Non renseigné</span></h3>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li v-for="(maintenance, index) in oldMaintenances" :key="`maintenance-${index}`">
                                <div class="orange-dot">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.48795 4.25756e-06C8.88522 -0.000129502 8.29026 0.135945 7.74752 0.398059C7.20478 0.660174 6.72828 1.04155 6.35365 1.5137C5.97901 1.98584 5.71591 2.53654 5.58401 3.12466C5.45211 3.71277 5.45483 4.32309 5.59195 4.91L0.540945 10.145C0.183718 10.5239 -0.0103905 11.028 0.000429211 11.5486C0.0112489 12.0693 0.226131 12.5648 0.598792 12.9286C0.971453 13.2923 1.47207 13.4951 1.99283 13.4933C2.51358 13.4916 3.01279 13.2853 3.38295 12.919L8.38995 7.847C9.02885 8.02887 9.70298 8.04883 10.3515 7.90509C11.0001 7.76136 11.6026 7.45844 12.1049 7.02367C12.6071 6.5889 12.9932 6.03594 13.2284 5.41467C13.4636 4.79341 13.5404 4.12337 13.4519 3.465C13.4397 3.37244 13.4017 3.28516 13.3424 3.21306C13.283 3.14096 13.2047 3.08691 13.1162 3.05704C13.0278 3.02717 12.9327 3.02267 12.8418 3.04405C12.7509 3.06543 12.6678 3.11183 12.6019 3.178L10.4879 5.293L8.19495 3L10.3099 0.885004C10.3761 0.819126 10.4225 0.736033 10.4439 0.645138C10.4653 0.554243 10.4608 0.459177 10.4309 0.370709C10.401 0.28224 10.347 0.203904 10.2749 0.144573C10.2028 0.0852411 10.1155 0.0472853 10.0229 0.0350042C9.84526 0.0114363 9.66619 -0.000256228 9.48695 4.25756e-06H9.48795Z" fill="black"/>
                                    </svg>
                                </div>
                                <div class="flex-column">
                                    <div class="block-date">
                                        <img v-if="maintenance.date" src="https://www.ewigo.com/wp-content/themes/ewigo/assets/images/calendrier-noir.svg" alt="" class="icon">
                                        <div class="date" v-if="maintenance.date">
                                            {{dateTime(maintenance.date)}}
                                        </div>
                                    </div>
                                    <div class="block-mileage">
                                        <img v-if="maintenance.mileage && !maintenance.mileage.toString().includes('entretien')" src="https://www.ewigo.com/wp-content/themes/ewigo/assets/images/compteur-intelligent-noir.svg" alt="" class="icon">
                                        <div class="text">
                                            <h3 class="title">{{maintenance.mileage}}<span v-if="maintenance.mileage && !maintenance.mileage.toString().includes('entretien')"> km</span></h3>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="mot-conseiller">
                        <div class="img-conseiller">
                            <img class="lazyload" :data-src="ad.photo_sales" alt="">
                        </div>

                        <div class="content">
                            <h2 class="title">Le mot de votre conseiller Ewigo</h2>

                            <!-- Catégories spécifiques -->
                            <p v-if="ad.category == 'COUPÉ'">
                                Envie d’une voiture aux lignes élégantes ? Pour une conduite plaisir qui ne sacrifie pas le confort et la sécurité, cette {{ad.make}} {{ad.model}} est la voiture idéale !
                            </p>

                            <p v-else-if="ad.energy == 'HYBRIDE ( ESSENCE - ELECTRIQUE )' || ad.energy == 'ELECTRIQUE'">
                                Vous souhaitez trouver votre nouvelle voiture respectueuse de l’environnement ? Pour vos déplacements, ne manquez pas la {{ad.make}} {{ad.model}}. Économique, fiable et silencieuse, elle séduit par son faible impact environnemental.
                            </p>

                            <p v-else-if="ad.category == 'BREAK'">
                                Vous recherchez le break parfait pour vos déplacements en famille ou entre amis ? Le break {{ad.make}} {{ad.model}} pourrait bien répondre à toutes vos envies.
                            </p>

                            <p v-else-if="ad.category == 'CABRIOLET' || ad.category == 'COUPÉ CABRIOLET'">
                                Véritable achat plaisir, ce cabriolet {{ad.make}} {{ad.model}} se démarque. À vous la liberté et la conduite : ce véhicule {{ ad.energy }} vous accompagnera lors de vos promenades en nature.
                            </p>

                            <p v-else-if="['SUV', 'PICK-UP', '4x4', 'SUV/4X4/CROSSOVER', 'SUV/4X4', '4x4, SUV'].includes(ad.category)">
                                Avec ce {{ad.make}} {{ad.model}}, charisme et performance sont à l’honneur ! Ce véhicule {{ad.seats_count}} places est votre transporteur tout terrain, s’adaptant à votre quotidien.
                            </p>

                            <p v-else-if="ad.category == 'MONOSPACE'">
                                Vous êtes à la recherche du parfait monospace pour vos trajets en famille ? Le {{ad.make}} {{ad.model}} pourrait bien devenir votre allié avec sa modularité et son confort intérieur.
                            </p>

                            <p v-else-if="ad.category == 'CITADINE'">
                                Vous recherchez la parfaite citadine ? La {{ad.make}} {{ad.model}}, avec ses {{ad.seats_count}} places et {{ad.doors_count}} portes, est idéale pour faciliter votre conduite en ville.
                            </p>

                            <p v-else-if="ad.category == 'BERLINE'">
                                Routière par excellence, la berline {{ad.make}} {{ad.model}} allie confort et élégance pour tous vos longs trajets.
                            </p>

                            <p v-else-if="ad.category == 'COMPACT'">
                                Besoin d’un véhicule polyvalent ? Notre {{ad.make}} {{ad.model}} est parfait pour tous vos déplacements quotidiens grâce à son habitabilité et son élégance.
                            </p>

                            <p v-else-if="ad.category == 'ROADSTER'">
                                Envie de style ? Le roadster {{ad.make}} {{ad.model}} vous offre des sensations de conduite uniques en ville ou sur route ouverte.
                            </p>

                            <p v-else-if="ad.category == 'Autre'">
                                À la recherche d'un véhicule unique ? Découvrez notre {{ad.make}} {{ad.model}}, une offre distinguée par ses caractéristiques et son originalité.
                            </p>

                            <!-- Informations communes -->
                            <p>
                                Mise en circulation le {{ dateTime(ad.market_release_date) }}, {{ad.make}} {{ad.model}} possède {{ad.kms}} kms au compteur. Contactez-nous par téléphone, mail ou SMS pour plus de renseignements !
                            </p>
                        </div>
                  </div>
                </div>
            </section>


            <section class="page-header-section details-section">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-4">
                            <div class="reprise card">
                                <div class="content">

                                    <h3 class="title">LA REPRISE</h3>
                                    <p>
                                        Besoin d’une solution de reprise pour votre véhicule ?<br /> <br />Réalisez une
                                        estimation gratuite ! </p>
                                    <form :action="route('minisite.landing-page-reprise-depot')" method="get" class="form-block">
                                        <div class="input-box">
                                            <input type="hidden" :value="ad.id" name="reference">
                                            <input type="text" placeholder="Numéro d’immatriculation " name="registration">
                                        </div>
                                        <div class="submit-button">
                                            <input type="submit">
                                        </div>
                                    </form>
                                </div>
                                <div class="image">
                                    <img :src="ad.first_image"
                                        alt="" class="img-fluid">
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8">
                            <div class="livraison card">
                                <img class="lazyload" data-src="https://www.ewigo.com/wp-content/uploads/2022/10/livraison-opti.jpg"
                                    alt="">
                                <div class="content">
                                    <h3 class="title">LA LIVRAISON</h3>
                                    <p>
                                        Bénéficiez de la livraison de votre véhicule partout en France ! </p>
                                    <div class="text-center">
                                        <a class="primary-btn btn" href="#livraison">
                                            Voir les options de livraison </a>
                                    </div>
                                </div>
                            </div>
                            <div class="image img-garantie img-garantie-desktop" style="margin-top: 20px;">
                                <img src="/img/la-garantie.png" alt=""
                                    class="img-fluid">
                            </div>
                            <div class="image img-garantie img-garantie-mobile" style="margin-top: 20px;">
                                <img src="/img/garantie-mobile-incluse.png" alt="" class="img-fluid">
                            </div>
                            <div class="image img-garantie img-garantie-mobile" style="margin-top: 20px; padding-bottom: 55px;">
                                <img src="/img/garantie-mobile-extension.png" alt="" class="img-fluid">
                            </div>
                            <div class="text-center btn-garantie">
                                <a class="primary-btn btn" :href="route('minisite.services')+'#garantie'">
                                    Voir les options de garantie
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </Layout>
    <Footer :agency="agency" :bg_img="bg_img"></Footer>
</template>

<script>
  import _ from 'lodash';
  import Layout from './Layout'
  import { Head } from '@inertiajs/inertia-vue3'
  import Footer from "@/Pages/Partials/Footer"
  import Header from "@/Pages/Partials/Header"
  import moment from 'moment';
  import VueEasyLightbox from 'vue-easy-lightbox';
  import ShareButton from '@/Pages/Partials/ShareButton';

import {mask} from 'vue-the-mask'
export default {
    directives: {mask},
    components: {
      Head,
      Layout,
      Footer,
      Header,
      VueEasyLightbox,
      ShareButton,
    },
    props: {
      agency: Object,
      ad: Object,
      pneus: Object,
      title: String,
      description:String,
      bg_img: String,
      body_class: String,
      maintenance_history: Array
    },
    data() {
        return {
            lightboxVisible: false,
            lightboxIndex: 0,
            contactResult: false,
            lenboxData: false,
            driivemeData: false,
            showEquipments: false,
            shippingAddress: null,
            image: {
                backgroundImage: "url('" + this.ad.first_image + "')"
            },
            apport: this.ad.lenbox_amount,
            duree: 72,
            lenboxUrl: false,
            phone: null,
            currentQuestion: false,
            screens: {},
            subTabs: ['avant', 'arriere', 'droite', 'gauche', 'habitacle', 'equipements'],
            registration: null,
            futureMaintenances: [],
            oldMaintenances: [],
            favoris: [],


            form: this.$inertia.form({
                id: this.ad.id,
            }),

            inFavorites: false,
        }
    },
    methods: {
        refreshFavoris() {
            if (this.favoris) {
                this.inFavorites = this.favoris.includes(this.ad.id);
            }
        },
        addToFavoris() {
            this.inFavorites = !this.inFavorites;
            // on ajoute au favoris

            //this.form.post('https://wvw.ewigo.com/favoris', {
            axios.post(route('api.favoris.post'), {
                id: this.ad.id,
            })
        },
        showLightboxImg(index) {
            this.lightboxIndex = index
            this.lightboxVisible = true
        },
        handleLightboxHide() {
            this.lightboxVisible = false
        },
        dateTime(value) {
            return moment(value).format('DD/MM/YYYY');
        },
        usurePercentage: function(value){
            let tmp = value - 1;
            let result = tmp * 100 / 8;
            result = 100 - result;
            return Math.round(result);
        },
        driiveme() {
            axios.post(route('minisite.driiveme.post', {address: this.shippingAddress, reference: this.ad.id}))
                .then((response) => {
                    this.driivemeData = response.data
                })
        },
        lenbox() {
            axios.post(route('minisite.lenbox.post', {apport: this.apport, duree: this.duree, reference: this.ad.id}))
                .then((response) => {
                    this.lenboxData = response.data
                    if (this.lenboxData.status === 'success') {
                        this.lenboxUrl = this.lenboxData.response.url
                    }
                })
        },
        contact() {
            axios.post(route('ad.send.phone', this.ad.id), {phone: this.phone})
                .then((response) => {
                    this.contactResult = true
                })
                .catch(function (error) {
                    alert(error.response.data.message);
                });
        },
        checkQuestions( questions ) {
            let findError = false;
            if (questions) {
                questions.forEach(function (question) {
                    if (question.value == "0") findError = true;
                });
            }

            return findError;
        },
        getMaintenanceHistory() {
            const dateNow = new Date();
            const futureMaintenancesTest = [];
            this.maintenance_history.forEach(element => {
                const dateMaintenance = new Date(element.date);
                if (dateMaintenance > dateNow) {
                    futureMaintenancesTest.push(element);
                } else {
                    this.oldMaintenances.push(element);
                }
            });
            if (futureMaintenancesTest.length == 0) futureMaintenancesTest.push({});
            return futureMaintenancesTest;
        },
    },
    watch: {
        apport: {
            deep: true,
            handler: _.debounce(function () {
                this.lenbox()
            }, 100)
        },
        favoris: {
            deep: true,
            immediate: true,
            handler(newVal, oldVal) {
                this.refreshFavoris();
            }
        }
    },
    created() {
        this.screens = this.ad.inspection;
        this.futureMaintenances = this.getMaintenanceHistory();

        axios.get(route('api.favoris.get')).then((response) => {
            this.favoris = Object.values(response.data)
        });
    },
    mounted () {
        document.body.classList.add(this.body_class.split(' '))
        this.lenbox()
        document.addEventListener("click", this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    destroyed () {
        document.body.classList.remove(this.body_class.split(' '))
    },
    computed: {
        apportMax() {
            // 9999 - 5000 = 4999 -> 4900
            return _.floor(this.ad.price / 100) * 100 - 5000;
        },
        mensualite() {
            if (!this.lenboxData || !this.lenboxData.response) return 0;
            if (this.duree == 72) return this.lenboxData.response.mensualite_72
            if (this.duree == 60) return this.lenboxData.response.mensualite_60
            if (this.duree == 48) return this.lenboxData.response.mensualite_48
            if (this.duree == 36) return this.lenboxData.response.mensualite_36
            if (this.duree == 24) return this.lenboxData.response.mensualite_24
            if (this.duree == 12) return this.lenboxData.response.mensualite_12
        },
        getRegistrationMask()
        {
            if (!this.registration) return 'X';
            if (!isNaN(this.registration.charAt(0)))
            {
                return '#### AAA ##';
            }else{
                return 'AA-###-AA';
            }
        },
        gear() {
            const gear = this.ad.gear.toUpperCase();
            switch (gear) {
                case "MANUELLE":
                    return "Meca";
                case "AUTOMATIQUE":
                    return "Auto";
                default:
                    return this.ad.gear;
            }
        },
        energy() {
            if (this.ad.energy.toUpperCase() == "ELECTRIQUE"){
                return "Elec";
            } else {
                return this.ad.energy;
            }
        },
        km() {
            return this.ad.kms.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        },
    }
}
</script>
<style lang="scss" scoped>
.block-icons {
    flex-wrap: wrap;
}
/* A decommenter lors de l'ajout du 6eme picto */
@media screen and (max-width: 500px) {
    .block-icons {
        margin: 0 60px !important;
    }
    .icon {
        flex: 33%;
    }
}

@media screen and (max-width: 370px) {
    .block-icons {
        margin: 0 20px !important;
    }
    .price {
        padding: 0 20px !important;
    }
}

.noAnomaly {
    flex: 100%;
}


@media screen and (min-width: 991px) {
    .like-button {
        top: 130px !important;
    }
    .share-button {
        width: 30px;
        height: 30px;
        background-repeat: no-repeat;
        background-size: 26px;
        background-position: center;
        cursor: pointer;
        position: absolute;
        right: 100px;
        transition: all 0.4s ease 0s;
        z-index: 11;
        top: 130px !important
    }
    .car-title {
        top: 120px !important;
    }
    .title-pneus-desktop {
        display: block;
    }
    .etats-des-pneus {
        margin-top: -30px;
        .row .col-lg-4:first-child {
            display: none;
        }
    }
    .historique {
        margin-bottom: 50px;
    }
}
@media screen and (max-width: 990px) {
    .like-button {
        top: 25px !important;
        right: 25px !important;
    }
    .share-button {
        top: 25px !important;
        right: 22px !important;
    }
    .reserve-vehicle {
        h2 {
            margin-bottom: 20px !important;
            font-size: 2.5rem !important;
        }
        h3 {
            font-size: 1.4rem !important;
            margin-bottom: 14px !important;
        }
    }
    .inspection .row {
        flex-direction: column-reverse;
        margin-top: 20px;
    }

    .etat-vehicle {
        margin-bottom: 0;
    }
    .etat-vehicle .newsletter-popup{
        display: flex;
        width: 97%;
    }
    .etats-des-pneus {
        padding-top: 120px !important;
        margin-top: 50px;
        .title-pneus-desktop {
            display: none;
        }
        img {
            margin-top: 20px;
            width: 50%;
            transform: translateX(50%);
        }
    }
}

@media screen and (max-width: 481px) {
    .price {
        padding: 0 25px !important;
        p{
            font-size: 2rem !important;
        }
    }
    .title {
        font-size: 2rem !important;
    }
}
.announce-header .car-title {
    -webkit-backdrop-filter: blur(30px);
    max-width: 95%;
}

.details-section h3 {
    font-weight: 600 !important;
}

.announce-timeline .timeline::before {
        content: " ";
        display: block;
        background-color: black;
        background-image: none;
        position: absolute;
        left: 3px;
        transform: translateX(50%);
        min-height: 270px;
        width: 4px;
}
.announce-timeline .timeline li {
    padding: 25px 0;
    display: block;
}

.announce-timeline .timeline  .flex-column {
    margin-top: 10px;
}

.driiveme {
    margin-top: 20px;
}
.etat-vehicle .newsletter-popup{
    z-index:100;
    position: absolute;
    bottom: -200px;
}

.submit-button [type=submit]{
    cursor:  pointer!important;
}


.inspection {
    color: #878173;
}

.inspection .replace_tires {
    width: 100%;
    color: #DF2121;
}

.inspection .title {
    border-bottom: 1px solid rgba(135, 129, 115, 0.1);
    color: #FD753B;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    margin: 0 22px;
    padding: 12px 0;
    text-align: center;
}

.inspection .block-container {
    padding: 0;
}


.inspection .steps {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-evenly;
}

.inspection .steps a {
    height: 40px;
    line-height: 40px;
    color: #878173;
    text-decoration: none;
    text-transform: uppercase;
}

.inspection .steps a.active {
    border-bottom: 2px solid #FD753B;
    color: #FD753B;
}

.inspection .steps a.active:after {
    content: "";
    display: block;
    width: 100%;
    bottom: 0px;
}

.inspection .substeps {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: flex-start;
    padding-left: 10px;
}

.inspection .substeps a {
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 0 20px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 30px;
    font-size: 16px;
    line-height: 43px;
    text-decoration: none;
    text-transform: uppercase;
    text-align: center;
    color: #878173;
    display: flex;
}

.inspection .substeps a img {
    padding-right: 10px;
}

.inspection .substeps a.active {
    background: linear-gradient(270deg, #F9B104 0%, #FD753B 100%);
    color: #fff;
}

.inspection .step-1,
.inspection .step-3 {
    text-align: center;
}

.inspection .step-1 label,
.inspection .step-3 label {
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #878173;
    padding-top: 20px;
    padding-bottom: 5px;
    display: block;
}

.inspection .subtitle {
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #878173;
    padding-top: 20px;
    padding-bottom: 5px;
    display: block;
    text-transform: uppercase;
    text-align: center;
}

.inspection .subtitle-info {
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    color: #E0E0E0;
}

.inspection .plate-input {
    width: 90%;
    height: 46px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    box-sizing: border-box;
    border-radius: 30px;
    text-align: center;
    max-width: 400px;
}

.inspection .plate-input::placeholder {
    color: #E0E0E0;
}

.inspection .plate-input.active {
    background-image: url("/inspector-images/check.svg");
    background-repeat: no-repeat;
    background-position-x: 95%;
    background-position-y: center;
}

.inspection .block-img {
    background: #4F4F4F;
}

.inspection .block-img img {
    width: 80%;
    max-width: 400px;
    height: auto;
}

.inspection input[type='submit'] {
    padding: 10px 15px;
    height: 37px;
    background: #FD753B;
    border-radius: 3px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    color: #FFFFFF;
    margin: 20px 0;
}

.inspection input[type='submit']:disabled {
    background: rgba(253, 117, 59, 0.8);
}

.inspection .block-column {
    margin: 0 10px;
    display: flex;
    text-align: left;
    align-items: center;
    justify-content: center;
}

.inspection .block-column img {
    margin-right: 10px;
}

.inspection .identification {
    background: #FFFFFF;
    border-radius: 6px;
    margin: 10px;
    overflow: hidden;
}

.inspection .identification .identitle {
    background: linear-gradient(270deg, #F9B104 0%, #FD753B 100%);
    color: #FFFFFF;
    margin: 0;
    font-weight: 600;
    font-size: 16px;
    height: 46px;
    line-height: 46px;
}

.inspection .identification dl {
    text-align: left;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 34px;
    color: #878173;
    padding: 0 15px;
}

.inspection .identification dt span {
    letter-spacing: 0.25px;
    color: #878173;
    font-size: 14px;
    background: rgba(135, 129, 115, 0.1);
    border-radius: 3px;
    padding: 1px 5px;
    margin-left: 5px;
}

.inspection .current-progress-bar {
    padding: 10px 40px;
    display: flex;
    align-items: center;
}

.inspection .current-progress-bar .percentage {
    margin-left: 20px;
}

.inspection .progress-bar {
    width: 100%;
}

.inspection .progress-bar .bar {
    border: 1px solid #e4e4e4;
    border-radius: 10px;
    height: 11px;
    position: relative;
    overflow: hidden;
    width: 100%;
    background-color: #eee;
}

.inspection .progress-bar .bar-fill {
    background-color: #F9B104;
    background-image: linear-gradient(270deg, #F9B104 0%, #FD753B 100%);
    background-size: 35px 35px;
    box-shadow: inset 0 -1px 2px rgba(0, 0, 0, 0.1);
    display: block;
    float: left;
    height: 18px;
    transition: none 0s ease 0s;
}


.inspection .block-question {
    margin: 4px;
    padding: 10px 0 10px 20px;
    background: #FFFFFF;
    border-radius: 6px;
    border: 2px solid #fff;
    width: 48%;
}

.inspection .block-question .question {
    margin-right: 15px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #878173;
}

.inspection .block-question .response {
    display: flex;
    user-select: none;
}

.inspection .block-question.qwarning,
.inspection .block-question.qsuccess,
.inspection .block-question.qerror,
.inspection .block-question.qinfo {
    box-sizing: border-box;
    border-radius: 6px;
    background: #FFFFFF;
}

.inspection .block-question.qwarning {
    border: 2px solid #FD753B;
}

.inspection .block-question.qsuccess {
    background-image: url("/images/check.svg");
    background-repeat: no-repeat;
    background-position-x: 0%;
    background-position-y: center;
}

.inspection .block-question.qerror {
    background-image: url("/images/error.svg");
    background-repeat: no-repeat;
    background-position-x: 0%;
    background-position-y: 10px;
    flex-wrap: wrap;
}

.inspection .block-question.qinfo {
    border: 2px solid #15849C;
    display: none;
}

.inspection .block-question .problem {
    display: flex;
    align-items: center;
    width: 100%;
}

.inspection .block-question .problem img {
    padding: 10px 10px 10px 0;
}

.inspection .block-question .problem span {
    font-weight: bold;
    font-size: 14px;
    color: #878173;
    display: none;
}

.inspection .block-question .problem .content {
    font-size: 12px;
    line-height: 15px;
    color: #878173;
}

.inspection .block-question .problem .content p{
    color: #fe8901;
    font-size: 12px;
}

.inspection input[type="radio"]+label {
    cursor: pointer;
    position: relative;
    padding-left: 30px;
    margin-right: 10px;
    height: 22px;
    font-size: 13px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    padding-top: 0;
    padding-bottom: 0;
}

.inspection input[type="radio"]+label:before {
    content: "";
    display: block;
    width: 22px;
    height: 22px;
    margin-right: 14px;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #E0E0E0;
    background-color: #fff;
    border-radius: 50%;
}

.inspection input[type="radio"] {
    display: none !important;
    *display: inline;
}

.inspection input[type="radio"]:checked+label:after {
    content: "";
    display: block;
    position: absolute;
    top: 4px;
    left: 4px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: linear-gradient(270deg, #F9B104 0%, #FD753B 100%);
}

.inspection input[type="radio"]:checked+label:before {
    border: 1px solid #FD753B;
}

.inspection .preview {
    margin: 0;
    padding: 22px 0 22px 0;
    background: #FFFFFF;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    position: relative;
}

.inspection .preview .canvas {
    position: relative;
}

.inspection .bubble-question {
    position: absolute;
    background: #E0E0E0;
    border-radius: 30px;
    font-size: 12px;
    text-align: center;
    padding: 0;
    overflow: hidden;
    margin: 0;
    width: 50px;
}
.inspection .bubble-question a{
    width: 100%;
    height: 100%;
    color: #fff;
    text-decoration: none;
    display: block;
}

.inspection .bubble-question.qwarning {
    background-color: #FD753B;
    color: #FFFFFF;
}

.inspection .bubble-question.qsuccess {
    background-color: #6FCF97;
    color: #FFFFFF;
    display: none;
}

.inspection .bubble-question.qerror {
    background-color: #FF8900;
    color: #FFFFFF;
    padding-top:10px;
    padding-bottom:5px;
}

.inspection .bubble-question.qinfo {
    background-color: #15849C;
    color: #FFFFFF;
}

.inspection .modalOverlay {
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    z-index: 10;
    position: fixed;
    display: block;
    top: 0;
    left: 0;
    backdrop-filter: blur(2px);
}

.inspection .modal {
    background: #FFFFFF;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    width: 90vw;
    max-width: 600px;
    height: auto;
    max-height: 90vh;
    z-index: 15;
    left: 50%;
    top: 50%;
    position: fixed;
    transform: translate(-50%, -50%);
    padding: 0;
    text-align: center;
}

.inspection .modal img,
.inspection .modal video,
.inspection .modal canvas {
    width: 100%;
    height: 250px;
    overflow: hidden;
    margin-bottom: 10px;
}

.inspection .modal label {
    text-align: left;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #878173;
    width: 100%;
    display: block;
}

.inspection .modal textarea {
    border: 1px solid #E0E0E0;
    box-sizing: border-box;
    border-radius: 6px;
    width: 100%;
    height: 160px;
    padding: 10px;
}

.inspection .list-response {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 10px;
}

.inspection .list-response input[type='radio'] {
    display: none;
}

.inspection .list-response input[type="radio"]+label:before {
    content: none;
}

.inspection .list-response input[type="radio"]+label {
    background: #E0E0E0;
    border-radius: 30px;
    font-size: 12px;
    text-align: center;
    padding: 5px 10px;
    cursor: pointer;
    margin: 4px 10px 4px 0;
}

.inspection .list-response input[type="radio"]:checked+label:after {
    content: none;
}

.inspection .list-response input[type="radio"]:checked+label {
    background: #FD753B;
    color: #fff;
}

.inspection .block-radio,
.inspection .block-inputs {
    flex-wrap: wrap;
    justify-content: flex-start;
}

.inspection .block-inputs label {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #878173;
    margin-right: 20px;
    padding: 0;
}

.inspection .block-inputs .block-input {
    display: flex;
    margin: 10px 0;
    justify-content: flex-end;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
}

.inspection .range-usure {
    background-image: url("/inspector-images/range-2.svg");
    background-repeat: no-repeat;
    width: 300px;
    height: 39px;
    position: relative;
}

.inspection .range-usure input[type='range'] {
    -webkit-appearance: none;
    /*nécessaire pour Chrome */
    padding: 0;
    /* nécessaire pour IE */
    font: inherit;
    /* même rendu suivant font document */
    outline: none;
    color: #56ca0e;
    /* sert pour couleur de référence, via currentColor, pour le curseur */
    background: transparent;
    /* sert pour couleur de fond de la zone de déplacement */
    box-sizing: border-box;
    /* même modèle de boîte pour tous */
    cursor: pointer;
    width: 280px;
    position: absolute;
    bottom: -4px;
    left: 0;
}

.inspection .range-usure input[type='range']::-webkit-slider-thumb {
    /* Override default look */
    appearance: none;
    width: 22px;
    /* Set a specific slider handle width */
    height: 22px;
    /* Slider handle height */
    border-radius: 100%;
    background: #56ca0e;
    /* Green background */
    cursor: pointer;
    /* Cursor on hover */
}

.inspection .block-vin {
    width: 72px;
    height: 72px;
    background-image: url('/inspector-images/photo.svg');
    background-repeat: no-repeat;
    background-position-y: 5px;
}

.inspection .block-vin label {
    text-indent: -10000em;
    width: 72px;
    height: 72px;
    padding: 0;
    margin: 0;
    cursor: pointer;
}

.inspection .block-vin input[type=file] {
    display: none;
}

.inspection .cotation {
    background-color: #15849C !important;
    margin-top: 0!important;
}

.inspection .block-questions {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: flex-start;
}

@media (min-width: 1280px) {
    .inspection [class*='substep-'] {
        display: flex;
    }

    .inspection .preview,
    .inspection .documents,
    .inspection .block-questions {
        width: 50%;
        height: 457px;
    }



    .inspection .substeps {
        justify-content: center;
        overflow-x: none;
        padding-left: 0;
    }

    .inspection .substeps a {
        margin-bottom: 0;
    }

    .inspection .canvas {
        top: 0;
        position: absolute;
        transform-origin: top;
    }
/*'avant', 'arriere', 'droite', 'gauche', 'habitacle', 'equipements', 'pneus', 'mecanique'*/

    .inspection .substep-avant .canvas,
    .inspection .substep-arriere .canvas {
        transform: scale(1);
    }

    .inspection .substep-droite .canvas,
    .inspection .substep-gauche .canvas,
    .inspection .substep-pneus .canvas {
        transform: scale(1);
    }
}
@media (min-width: 1280px) and (max-width: 1685px) {
    .inspection .substep-droite .canvas,
    .inspection .substep-gauche .canvas,
    .inspection .substep-pneus .canvas {
        transform: scale(0.8);
    }
}

@media (max-width:1024px) {
    .inspection .canvas {
        transform: scale(0.9);
        top: 0;
        position: absolute;
        transform-origin: top;
    }

    .inspection .substep-droite .canvas,
    .inspection .substep-gauche .canvas,
    .inspection .substep-pneus .canvas {
        transform: scale(0.6);
    }
}

.response {
    display: none !important;
}

.slider-nav img {
    max-height : 100px;
}

.slider-nav .slide {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
}

.slider-nav .slick-slide {
    margin: 2px;
    border: 1px solid #FD753B;
    padding: 3px;
    border-radius: 10px;
}

.slider-nav .slick-slide .slide img {
    margin: 5px;
}

@media screen and (min-width: 991px) {

    .etat-vehicle{
        margin-bottom: 140px;
    }
}

.etats-des-pneus{
    padding-top: 100px;
}

.announce-timeline .timeline .text::before {
    left: -16px;
    display: none;
}

p{
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}

.counseller .content {
    padding: 30px 60px;
}



.submit-button input:hover {
    background-color: #262626;
    border: 1px solid #262626;
}
/* modele prix pictos */
.car-title, .price {
    padding: 0 75px 0 90px;
}
.car-title .title {
    font-size: 2.5rem;
}
.car-title .sub-title {
    font-size: 1.5rem;
    margin: 0;
}
.price {
    top: 230px;
}
.price p {
    font-size: 3rem;
    margin: 0;
}
.icon img {
    height: 35px;
}
@media only screen and (max-width: 1024px) {
    .car-title .sub-title {
        font-size: 1.1rem;
    }
    .icon img {
        height: 30px;
    }
}
/* ------------------- */
/* Bloc photos et financement */
.announce-calculator .container .row {
    align-items: center;
}
.announce-calculator .container .row .slick-list .draggable{
    max-height: 600px;
}

.announce-calculator .slick-slide img
{

    margin: 0 auto;
    height: 715px;
    width: auto;
    object-fit: cover;
}
/* ------------------- */
/* Réserver véhicule */
.reserve-vehicle {
    padding: 25px 0;
}
.reserve-vehicle .address-col {
    padding: 0;
    margin-top: 0;
    .title {
        margin-bottom: 0;
    }
}
.reserve-vehicle .section-header {
    padding-bottom: 0;
}
/* ----------------------- */
/* equipements et options */
.section-inner {
    padding: 0;
}
.left-image-list {
    padding-bottom: 0;
}
.right-image-list {
    padding-top: 0;
}
.image-desktop {
      display: block
}
.image-mobile {
    display: none;
}
@media only screen and (max-width: 1024px) {
  .image-desktop {
      display: none
  }
  .image-mobile {
      display: block;
  }
}
/* ----------------------- */
/* Historique d'entretien */
.flex-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 70px;
}
.block-date,.block-mileage {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.timeline {
    position: relative;
}
.announce-timeline .container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-around;
}

.announce-timeline .icon {
    width: 25px;
    height: 25px;
    margin-right: 20px;
}
@media only screen and (max-width: 1024px) {
    .announce-timeline .container {
        flex-direction: column;
    }
    .announce-timeline .img-fluid{
        margin-top: 20px;
    }
}
.announce-timeline .timeline li:first-child {
    padding-top: 70px;
}

.announce-timeline li .text{
    padding-left: 0;
}
.announce-timeline .timeline .date{
    font-size: 1.0rem;
}
.announce-timeline li .title{
    font-size: 1.2rem;
}
@media only screen and (max-width: 1024px) {
    .announce-timeline .timeline .date{
        font-size: 1rem;
    }
    .announce-timeline li .title{
        font-size: 1.4rem;
    }
}
.announce-timeline h2.title{
    text-transform: uppercase;
}

.announce-timeline li {
    justify-content: center;
}
.orange-dot {
    display: block;
    position: absolute;
    width: 40px;
    height: 40px;
    background: #ff9300;
    border-radius: 50%;
    left: -13px;
}
.grey-dot {
    background: rgba(128, 128, 128);
}
.orange-dot svg {
    left: 50%;
    top: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
}
/* ----------------------- */
.counseller {
    padding-top: 180px;
}
.counseller .title {
    text-transform: uppercase;
    font-size: 2.5rem;
    padding: 80px 30px;
}
.counseller .content .title {
    padding: 10px;
}
.details-section {
    margin-top: -120px;
    padding-top: 90px;
}
@media only screen and (max-width: 1024px) {
    .counseller {
        padding-top: 0;
    }
    .counseller .content {
        margin-bottom: 20px;
    }
    .livraison {
        margin-top: 40px;
    }
    .counseller .display_none {
        display: none;
    }
}
.site-footer .contact-social .footer-networks a img {
    width: 100%;
    height: 40px;
}

.etats-des-pneus table {
    white-space: nowrap;
}

.header-sliders .slider {
    right: -130px;
}

.header-sliders .slider:hover{
    right: 0px;
}

.reserve-vehicle .address-col.livraison .desc {
    margin-bottom: 14px;
}

.historique {
    position: relative;
}
.img-piston {
    position: absolute;
    left: -70px;
    top: -50px;
    opacity: 0.2;
    max-width: 140%;
}

.mot-conseiller {
    position: relative;
    max-width: 400px;
    text-align: center;
    border-radius: 30px;
    background-color: #dedede;
    padding: 20px;
    box-shadow: 0px 3px 6px rgb(0 0 0 / 16%);
}
.mot-conseiller .title {
    font-size: 1.5rem;
    padding-top: 75px;
    margin-bottom: 20px;
}

.img-conseiller img {
    position: absolute;
    transform: translate(-50%, -60%);
    max-width: 150px;
    max-height: 150px;
    border-radius: 150px;
}

.etat-vehicle .newsletter-popup img {
    border-radius: 160px;
    max-width: 150px;
    max-height: 150px;
}

.img-conseiller::before {
    content: "";
    width: 160px;
    height: 160px;
    border-radius: 271px;
    background: white;
    position: absolute;
    top: 0;
    transform: translate(-50%, -48%);
}
.img-garantie-mobile {
    display: none;
}
.btn-garantie {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    bottom: 10px;
}
.img-garantie-desktop{
    margin-top: 20px;
    background: white;
    padding-bottom: 40px;
    border-radius: 20px;
}
@media only screen and (max-width: 1024px) {
    .page-header-section .container {
        flex-direction: column;
        align-items: center;
    }
    .mot-conseiller {
        margin-top: 170px;
    }
    .img-piston {
        left: -50px;
        top: -60px;
        max-width: 130%;
    }
    .img-garantie-desktop {
        display: none;
    }
    .img-garantie-mobile {
        display: block;
        background: white;
        border-radius: 43px;
    }
    .details-section .img-garantie {
        margin-left: 0;
    }
}


.etats-des-pneus table tbody td {
    padding: 10px 16px;
}


@media (max-width: 480px){
    .announce-header .car-title {
        padding-right: 25px;
        padding-left: 25px;
    }
}

.sticky {
  position: sticky;
  top: 0;
  float: right;
}


.range-calculator {
    pointer-events: auto;
}

.future-maintenance-title {
    margin-bottom: 10px;
    padding-top: 12px;
    color: #ff9300;
    font-weight: bold;
}
.future-maintenance {
    padding-top: 0 !important;
}
.future-maintenance .title, .future-maintenance .date{
    color: #ff9300;
}


</style>
<style>
.slick-slider, .slick-list.draggable{
    padding: 0 !important;
    border-radius: 0 !important;
}

.inspection .slider-block .slick-slide img {
    height: 200px;
    width: auto;
    max-width: initial;
}

.toolbar-btn__resize, .toolbar-btn__rotate {
    display: none;
}



.vel-img {
    max-height: 100vh;
    max-width: 100vw;
}

</style>
